import React from 'react';

import styles from './Buttons.scss';
import ActionButton from './components/ActionButton/ActionButton';
import ClearBetSlipButton from './components/ClearBetSlipButton/ClearBetSlipButton';

const Buttons: React.FC = () => (
  <div className={styles.wrapper}>
    <ClearBetSlipButton />
    <ActionButton />
  </div>
);

export default Buttons;
